import { Link } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import { jwtDecode } from "jwt-decode";
import axios from "axios";

function VendorHeader() {

  const baseUrl =
    process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_BASE_URL_DEV
      : process.env.REACT_APP_BASE_URL_PROD;

  const languageDropdownRef = useRef(null);


  const baseUrl1 =
    process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_BASE_URL_DEV1
      : process.env.REACT_APP_BASE_URL_PROD1;

  const [notifications, setNotifications] = useState([]);

  const token = window.localStorage.getItem("tokenfirst");

  const decodedToken = jwtDecode(token);
  // console.log(decodedToken)


  const [isLanguageDropdownVisible, setLanguageDropdownVisible] =
    useState(false);
  const [selectedPage, setSelectedPage] = useState("dashboard");

  const toggleLanguageDropdown = () => {
    setLanguageDropdownVisible(!isLanguageDropdownVisible);
  };

  const closeDropdowns = () => {
    setLanguageDropdownVisible(false);
  };

  const handleOutsideClickLan = (event) => {
    if (
      languageDropdownRef.current &&
      !languageDropdownRef.current.contains(event.target)
    ) {
      closeDropdowns();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClickLan);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClickLan);
    };
  }, []);


  const [profileImage, setProfileImage] = useState("");

  useEffect(() => {

    const fetchProfileImage = async () => {
      const token = localStorage.getItem("tokenfirst");
      if (token) {
        try {
          const response = await axios.get(`${baseUrl}/vendorInfo/getprofile`, {
            headers: {
              Authorization: "Bearer " + token,
            },
          });
          setProfileImage(response.data?.path);
        } catch (error) {
          console.error("Error fetching profile image:", error);
        }
      }
    };

    fetchProfileImage();
  }, []); // 



  // 



  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const token = localStorage.getItem("tokenfirst");
        const decodedToken = jwtDecode(token);

        if (!token) {
          console.log('No token found');
          console.log(false);
          return;
        }

        const response = await fetch(`${baseUrl}/notificationvendor/getnotifications?vendorEmail=${decodedToken.email}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });

        const data = await response.json();

        if (response) {
          setNotifications(data.result.length);
          console.log(data)
        }
      } catch (err) {
        console.log('Error fetching notifications');
      } finally {
        console.log(false);
      }
    };

    fetchNotifications();
  }, []);
  // 


  function capitalizeName(name) {
    return name
      ?.split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }

  const handleLogout = () => {
    console.log("Logging out...");
    localStorage.clear();
    window.location.href = "/";
  };

  return (
    <>
      <div className="h-[75px] py-4 lg:flex justify-end pr-10 items-center border-b !w-full hidden">


        {/* <div className="flex gap-3 items-center"> */}

        <div className="flex gap-5 items-center">
          <button onClick={handleLogout} className="text-[#ffffff]  text-[12px] md:text-[14px] mr-1 bg-[#27648B] hover:bg-[#27648B] px-2 rounded-xl h-[30px]">
            Logout
          </button>


          <Link to={"/vendor/notification"}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="mask0_1840_7151" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                <rect width="24" height="24" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_1840_7151)">
                <path d="M4 19V17H6V10C6 8.61667 6.41667 7.3875 7.25 6.3125C8.08333 5.2375 9.16667 4.53333 10.5 4.2V3.5C10.5 3.08333 10.6458 2.72917 10.9375 2.4375C11.2292 2.14583 11.5833 2 12 2C12.4167 2 12.7708 2.14583 13.0625 2.4375C13.3542 2.72917 13.5 3.08333 13.5 3.5V4.2C14.8333 4.53333 15.9167 5.2375 16.75 6.3125C17.5833 7.3875 18 8.61667 18 10V17H20V19H4ZM12 22C11.45 22 10.9792 21.8042 10.5875 21.4125C10.1958 21.0208 10 20.55 10 20H14C14 20.55 13.8042 21.0208 13.4125 21.4125C13.0208 21.8042 12.55 22 12 22ZM8 17H16V10C16 8.9 15.6083 7.95833 14.825 7.175C14.0417 6.39167 13.1 6 12 6C10.9 6 9.95833 6.39167 9.175 7.175C8.39167 7.95833 8 8.9 8 10V17Z" fill="#2A668D" />
              </g>
            </svg>
            {notifications > 0 && (
              <span className="absolute top-4 right-[180px]  bg-red-500 text-white rounded-full w-3 h-3 flex justify-center items-center text-xs">
                {notifications}
              </span>
            )}
          </Link>
          <Link to="/vendor/settings" className="flex items-center space-x-4">
            {profileImage ? (
              <img
                src={`${baseUrl1}/${profileImage}`}
                alt="Profile"
                onError={(e) => { e.target.onerror = null; e.target.src = ""; }}
                className="rounded-full w-[50px] h-[50px] object-cover border border-gray-300"
              />
            ) : (
              <div className="w-[40px] h-[40px] py-4 rounded-full bg-gray-100 flex items-center justify-center border border-gray-300">
                <svg
                  className="w-4 h-4 text-gray-400"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    fillRule="evenodd"
                    d="M12 12c2.7 0 5-2.3 5-5s-2.3-5-5-5-5 2.3-5 5 2.3 5 5 5zm0 2c-3.3 0-10 1.7-10 5v2h20v-2c0-3.3-6.7-5-10-5z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
            )}

            <div className="max-w-[150px] truncate">
              <p
                className="text-[#27648B] font-semibold text-sm truncate"
                title={capitalizeName(decodedToken?.fullName)}
              >
                {capitalizeName(decodedToken?.fullName) || "Vendor"}
              </p>

            </div>
          </Link>
        </div>
        {/* </div> */}
      </div>
    </>
  );
}

export default VendorHeader;
